<template>
  <div>
    <aside
      ref="sidebar"
      v-click-outside="onClickOutsideSidebarDesktop"
      class="left-side-menu hide-scrollbar"
      :class="`${$vuetify.breakpoint.width < 768 && expanded ? 'is-expanded is-expanded-mobile' : $vuetify.breakpoint.width >= 768 && expanded ? 'is-expanded' : '' }`"
    >
      <div class="left-side-menu__content">
        <span class="logo d-md-flex align-items-center justify-content-between">
          <img
            src="/images/logo_nitro.svg"
            alt="Nitro Logo"
          >
          <button
            v-if="$vuetify.breakpoint.width > 767"
            id="sidebar-toggle"
            class="d-flex justify-center align-center"
            @click="onClickToggleSideBarDesktop"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.88"
              height="7.84"
            >
              <use xlink:href="#icon-expand" />
            </svg>

          </button>

        </span>
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon-expand hide-expanded mb-4 d-none d-md-block"
        >
          <use xlink:href="#icon-expand" />
        </svg> -->
        <div v-if="user">
          <StudentMenu v-if="user.is_student" />
          <SchoolMenu v-else />
        </div>
      </div>

      <!-- === Sidebar Footer Start ===  -->
      <div class="nav-user">
        <div class="nav-user__block">
          <IconUserInitials :full-name="user.name" />
          <div class="nav-user__content show-expanded d-flex flex-column justify-content-center mb-2">
            <h3 class="avatar-name mb-0 text-wrap mb-1">
              {{ user.name }}
            </h3>
            <!-- <p class="mb-0">{{$user->school->name}}</p>-->
            <span v-if="user.is_student && user.grade">
              {{ user.grade.name }}
            </span>
            <span
              v-if="user.is_student && user.school"
              class="mt-1"
            >
              {{ user.school.name }}
            </span>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>
<script>
import IconUserInitials from './IconUserInitials'
import StudentMenu from './sidebar/StudentMenu'
import SchoolMenu from './sidebar/SchoolMenu'
import { logout } from '../../utils/logout'
import { mapActions } from 'vuex'

export default {
  components: {
    SchoolMenu,
    StudentMenu,
    IconUserInitials
  },
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    expanded() {
      return this.$store.state.navbar_expanded
    },
  },
  mounted() {
    //Hacky
    this.$root.$on("outsideMobile", () => {
      this.onClickOutsideSidebarMobile();
    });
  },
  methods: {
    ...mapActions(['isLoading']),
    logout,
    onClickToggleSidebarMobile() {
      this.$store.state.navbar_expanded = !this.$store.state.navbar_expanded
    },
    onClickToggleSideBarDesktop() {
      const refSidebar = this.$refs.sidebar;
      if (refSidebar.style.width != "320px") {
        this.openMenu(refSidebar);
      }
      else {
        this.closeMenu(refSidebar);
      }

    },
    onClickOutsideSidebarDesktop() {
      const refSidebar = this.$refs.sidebar;
      if (this.$vuetify.breakpoint.width >= 768) {
        this.closeMenu(refSidebar);
      }
    },
    onClickOutsideSidebarMobile() {
      const refSidebar = this.$refs.sidebar;
      if (this.$vuetify.breakpoint.width < 768) {
        this.closeMenu(refSidebar);
      }
    },
    openMenu(refSidebar) {
      this.$store.state.navbar_expanded = true;
      refSidebar.style.width = "320px";
    },
    closeMenu(refSidebar) {
      this.$store.state.navbar_expanded = false;
      refSidebar.style.width = "80px";
    },
  },

}

</script>

